export default __webpack_public_path__ + "static/media/Path 201.06c3a408.svg";